import React, { useEffect, useState } from "react"
import { bindActionCreators } from "redux"
import {
  createStep,
  deleteProductFromStep,
  deleteStep,
  stepsList,
  updateStep,
} from "../../../../../../library/store/actions/creators/knowmixCreators"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { withRouter } from "react-router-dom"
import getErrorText from "../../../../../../library/constants/errorTypes"
import StepForm from "./stepForm/stepForm"
import AddOutlined from "@material-ui/icons/AddOutlined"
import AlertDialog from "../../../../../../components/ui/alertDialog/alertDialog"
import * as qs from "query-string"
import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"

const emptyStep = {
  name: "",
  description: "",
  standards: [],
  links: [],
  attachments: [],
  questions: [],
  products: [],
  time: 0,
}

const sharedUnit = JSON.parse(localStorage.getItem("unit"))

const KnowmixSettingsSteps = (props) => {
  const [initiatedWithUnit, setInitiatedWithUnit] = useState(false)
  const [list, setList] = useState(
    !!props.knowmix.stepsList.length
      ? props.knowmix.stepsList
      : !props.knowmix.currentKnowmix.is_finished
      ? [emptyStep]
      : []
  )
  const [canAdd, setCanAdd] = useState(!!props.knowmix.stepsList.length)
  const [openDeleteModal, setOpenDeleteModal] = useState({
    open: false,
    stepId: undefined,
  })
  const [isPublic] = useState(props.knowmix.currentKnowmix.is_finished)

  useEffect(() => {
    const { unitId } = qs.parse(props.location.search)

    if (unitId && sharedUnit?.id === parseInt(unitId, 10)) {
      addStep(sharedUnit)
    }

    setInitiatedWithUnit(true)

    // return () => localStorage.removeItem('unit')
  }, [])

  useEffect(() => {
    if (initiatedWithUnit) {
      setList(
        !!props.knowmix.stepsList.length ? props.knowmix.stepsList : [emptyStep]
      )
      setCanAdd(!!props.knowmix.stepsList.length)
    }
  }, [props.knowmix.stepsList])

  const addStep = (unit) => {
    const newStep = unit
      ? {
          ...emptyStep,
          unit,
          name: unit.name,
          standards: unit.standards,
          time: unit.minutes,
          description: unit.description,
          blobs: unit.blobs,
        }
      : emptyStep
    setList([...list, newStep])
    setCanAdd(false)
  }

  const createStep = async ({ step }) => {
    try {
      await props.createStep({
        knowmix_id: props.knowmix.currentKnowmix.id,
        ...step,
      })
      await props.getStepsList()
      localStorage.removeItem("unit")
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  const updateStep = async ({ step }) => {
    try {
      await props.updateStep(step)
      await props.enqueueSnackbar("Information updated", { variant: "success" })
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  const initiateStepDelete = (id) => {
    setOpenDeleteModal({ open: true, stepId: id })
  }

  const closeDialog = () => {
    setOpenDeleteModal({ open: false, stepId: undefined })
  }

  const deleteStep = async () => {
    try {
      await props.deleteStep({ id: openDeleteModal.stepId })
      closeDialog()
    } catch ({ error }) {
      props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  const deleteProduct = async ({ knowmix_step_id, product_id }) => {
    try {
      await props.deleteProductFromStep({ knowmix_step_id, product_id })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  return (
    <div className="box">
      <div className="box__heading">Steps</div>
      <div className="box__content">
        {list.map((item, i) => (
          <StepForm
            step={item}
            stepNumber={i + 1}
            createStep={createStep}
            updateStep={updateStep}
            deleteStep={initiateStepDelete}
            deleteProduct={deleteProduct}
            userData={props.auth.userData}
            disabled={isPublic}
            key={item.id || i}
          />
        ))}
        {/*{canAdd && !isPublic && (*/}
        {canAdd && (
          <div className="f aic jcc">
            <button className="btn btn--plain" onClick={() => addStep()}>
              <AddOutlined /> Add another step
            </button>
          </div>
        )}
      </div>

      <AlertDialog
        open={openDeleteModal.open}
        handleClose={closeDialog}
        handleAccept={deleteStep}
        title="Delete step from course?"
        message="If you delete this step you will not be able to restore it."
      />
    </div>
  )
}

const mapStateToProps = ({ auth, knowmix, standards }) => ({
  auth,
  knowmix,
  standards,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      stepsList,
      createStep,
      updateStep,
      deleteStep,
      deleteProductFromStep,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(withRouter(withErrorBoundary(KnowmixSettingsSteps))))
